@switch (menuStyle()) {
  @case (TabMenuStyle.SIMPLE) {
    <ng-template [ngTemplateOutlet]="tabButtonLink" />
  }
  @case (TabMenuStyle.RUNNER) {
    <ng-template [ngTemplateOutlet]="tabButtonLink" />
  }
  @case (TabMenuStyle.DEFAULT) {
    <button
      mat-flat-button
      class="mr-1 tab-button {{ menuStyle() }}"
      [ngClass]="{ 'active-button': item().active }"
      (click)="itemClick.emit(item())"
    >
      <twc-tab-menu-item
        [item]="item()"
        [menuItemArgument]="menuItemArgument()"
      />
    </button>
  }
}

<ng-template #tabButtonLink>
  <div
    class="tab-button-link cursor-pointer {{ menuStyle() }}"
    [ngClass]="{ active: item().active }"
    (click)="itemClick.emit(item())"
  >
    <twc-tab-menu-item
      [item]="item()"
      [menuItemArgument]="menuItemArgument()"
    />
  </div>
</ng-template>
